export enum MapVehiclePositionSource {
  NONE,
  LIVE_POSITION,
  LAST_KNOWN_POSITION,
  LAST_KNOWN_POINT,
}
